import { Component, Input } from '@angular/core';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';
import { UserService } from 'src/app/services/user.service';
import { ToastService } from 'src/app/services/toast.service';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from '../../.././environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() showEnvWarning: boolean;
  collapsed = false;
  public version = environment.buildTimestamp

  constructor(
    private router: Router,
    private authService: AuthService,
    private userService: UserService,
    private toastService: ToastService,
  ) { }

  refreshPermissions() {
    // Set Role
    let userInfo: any = localStorage.getItem('USER');
    this.userService.getIdentity(userInfo.idToken).then(permissions => {
      if (Object.keys(permissions.role).length == 0 && permissions.role.toLowerCase() != 'administrator') {
        this.toastService.showError('Access denied. Insufficient permissions!');
        this.router.navigate(['login']);
      } else {
        localStorage.setItem(LocalStorageKeyEnum.ROLE, JSON.stringify({ role: permissions.role }));
        location.reload();
      }
    }).catch(error => console.error(error));
  }

  logout() {
    this.authService.logout();
    window.location.replace('/login');
  }

}
